import React, {FC} from 'react';
import {pricingFlag} from '../../../images/svgIcons';
import './styles.scss';

const Flag: FC<{color?: string}> = ({color}) => {
  return <div className={`position-absolute ${color ? color : ''} price-flag`}>{pricingFlag}</div>;
};

export default Flag;
